export default function CTASection() {
  return (
    <section className="relative w-full h-[55vh] min-h-[420px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20horizontal%20fashion%20studio%20scene%20with%20curated%20clothing%20collection%20on%20display%20rails%20warm%20sand%20colored%20walls%20natural%20daylight%20from%20skylight%20editorial%20photography%20clean%20minimal%20aesthetic%20various%20textures%20wool%20cotton%20denim%20leather%20peaceful%20atmosphere&width=1800&height=800&seq=cta-bg-2701-x2&orientation=landscape"
        alt="PandabuySpreadsheet curated fashion collection"
        title="Explore PandabuySpreadsheet Database"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="lg:max-w-[480px]">
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.04]">
              ready to upgrade your wardrobe?
            </h2>
          </div>

          <div className="flex flex-col gap-6 items-start lg:items-end">
            <p className="text-white/70 text-base md:text-lg max-w-[320px] leading-relaxed lg:text-right">
              Curated daily drops. Verified product links. Structured spreadsheets for effortless discovery.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-white text-foreground-950 font-semibold text-sm hover:bg-white/90 transition-all hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
            >
              Explore All Finds
              <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}